import React from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { copyText } from "../../utils/copyText";

// eth1 = onboard port, eth2 = USB ethernet, wifi = USB Wi-Fi adapter (only when plugged in).
export const MAC_KEYS = [
  ["eth1", "mac_eth1"],
  ["eth2", "mac_eth2"],
  ["wifi", "mac_wifi"],
];

export function macEntries(edge) {
  return MAC_KEYS.map(([label, key]) => [label, edge?.[key]]).filter(([, mac]) => mac);
}

function CopyMac({ label, mac, compact }) {
  const { t } = useTranslation();
  const onCopy = async (ev) => {
    ev.stopPropagation(); // inside a clickable table row
    if (await copyText(mac)) toast.success(t("edges.mac.copied", { mac }));
    else toast.error(t("edges.mac.copyFailed"));
  };
  return (
    <button
      type="button"
      onClick={onCopy}
      title={t("edges.mac.copy", { label, mac })}
      aria-label={t("edges.mac.copy", { label, mac })}
      style={{
        all: "unset",
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        fontFamily: "monospace",
        fontSize: compact ? 11.5 : 13,
        color: "var(--text-muted)",
        padding: compact ? "1px 6px" : "3px 8px",
        border: "1px solid var(--border)",
        borderRadius: 6,
        background: "var(--bg-surface)",
      }}
    >
      <b style={{ fontFamily: "inherit", color: "var(--text-primary)" }}>{label}</b>
      <span>{mac}</span>
      <span aria-hidden="true">⧉</span>
    </button>
  );
}

// compact: one wrapped line under the edge name in the table; otherwise one chip per line (detail card).
export default function MacList({ edge, compact = false }) {
  const { t } = useTranslation();
  const entries = macEntries(edge);
  if (entries.length === 0) return compact ? null : <span style={{ color: "var(--text-muted)" }}>{t("edges.mac.none")}</span>;
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: compact ? 4 : 8, flexDirection: compact ? "row" : "column", alignItems: "flex-start", marginTop: compact ? 4 : 0 }}>
      {entries.map(([label, mac]) => (
        <CopyMac key={label} label={label} mac={mac} compact={compact} />
      ))}
    </div>
  );
}
